import { HorizontalBorderedName } from './templates/horizontal-bordered-name';
import { HorizontalColumnName } from './templates/horizontal-column-name';
import { svg as horizontalSplitPanelInitialsSvg } from './templates/horizontal-split-panel-initials';
import { svg as squareArcInitialsSvg } from './templates/square-arc-initials';
import { svg as squareDiamondColumnSvg } from './templates/square-diamond-column';
import { svg as squareOpenFrameInitialsSvg } from './templates/square-open-frame-initials';
import { svg as squareScalesMonogramSvg } from './templates/square-scales-monogram';
import { svg as squareVineOvalInitialsSvg } from './templates/square-vine-oval-initials';
import { svg as verticalWreathScalesNameSvg } from './templates/vertical-wreath-scales-name';
import type { TextSizing } from './types';

export const PUBLIC_LOGO_TEMPLATE_IDS = [
  'square-arc-initials',
  'horizontal-split-panel-initials',
  'horizontal-bordered-name',
  'square-diamond-column',
  'horizontal-column-name',
  'square-scales-monogram',
  'square-open-frame-initials',
  'vertical-wreath-scales-name',
  'square-vine-oval-initials',
] as const;

export type PublicLogoTemplateId = (typeof PUBLIC_LOGO_TEMPLATE_IDS)[number];

const PUBLIC_LOGO_TEMPLATE_ID_SET = new Set<string>(PUBLIC_LOGO_TEMPLATE_IDS);

export function isPublicLogoTemplateId(templateId: string): boolean {
  return PUBLIC_LOGO_TEMPLATE_ID_SET.has(templateId);
}

export const ADAPTIVE_COMPONENTS = {
  'horizontal-bordered-name': HorizontalBorderedName,
  'horizontal-column-name': HorizontalColumnName,
} as const;

export type AdaptiveLogoTemplateId = keyof typeof ADAPTIVE_COMPONENTS;

export const ADAPTIVE_LOGO_TEMPLATE_IDS = Object.keys(
  ADAPTIVE_COMPONENTS,
) as AdaptiveLogoTemplateId[];

const ADAPTIVE_LOGO_TEMPLATE_ID_SET = new Set<string>(ADAPTIVE_LOGO_TEMPLATE_IDS);

export function isAdaptiveLogoTemplateId(templateId: string): templateId is AdaptiveLogoTemplateId {
  return ADAPTIVE_LOGO_TEMPLATE_ID_SET.has(templateId);
}

export type StaticLogoSource = {
  rawSvg: string;
  textSizing?: TextSizing;
};

export const STATIC_LOGO_SOURCES: Record<string, StaticLogoSource> = {
  'square-arc-initials': { rawSvg: squareArcInitialsSvg },
  'horizontal-split-panel-initials': { rawSvg: horizontalSplitPanelInitialsSvg },
  'square-diamond-column': {
    rawSvg: squareDiamondColumnSvg,
    textSizing: { maxWidth: 360, baseSize: 50, minSize: 22, charWidth: 0.48 },
  },
  'square-scales-monogram': { rawSvg: squareScalesMonogramSvg },
  'square-open-frame-initials': { rawSvg: squareOpenFrameInitialsSvg },
  'vertical-wreath-scales-name': {
    rawSvg: verticalWreathScalesNameSvg,
    textSizing: { maxWidth: 340, baseSize: 46, minSize: 20, charWidth: 0.58 },
  },
  'square-vine-oval-initials': { rawSvg: squareVineOvalInitialsSvg },
};
